import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { OrganizationUnitItem } from '@features/user/models/filter-data.model';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export interface MembershipCommunityDialogData {
  communities: OrganizationUnitItem[];
  effectiveDateLabel: string;
}

@Component({
  selector: 'app-membership-community-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatRadioModule, ModalShellComponent],
  templateUrl: './membership-community-dialog.component.html',
  styleUrl: './membership-community-dialog.component.scss',
})
export class MembershipCommunityDialogComponent {
  readonly modalConfig: ModalShellConfig = {
    title: 'Elegir comunidad de pertenencia', size: 'md', layout: 'form',
  };
  readonly communityControl = new FormControl<string | null>(null, Validators.required);

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: MembershipCommunityDialogData,
    private readonly dialogRef: MatDialogRef<MembershipCommunityDialogComponent, string | null>,
  ) {}

  confirm(): void {
    const selectedId = this.communityControl.value;
    if (!selectedId || !this.data.communities.some(community => community.id === selectedId)) {
      this.communityControl.markAsTouched();
      return;
    }
    this.dialogRef.close(selectedId);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
